import {
  ParticipantFormFieldId,
  ParticipantsFormData,
} from '@/scopes/checkout/domain/types/checkoutPersonalDetails'
import { mapPhoneNumberToString } from '@/scopes/checkout/infrastructure/api/mapPhoneNumber'

export interface ParticipantsDetailsFormDataMapper {
  map: (formData: ParticipantsFormData) => { participants: Record<string, string>[] }
}

export function createParticipantsDetailsFormDataMapper(): ParticipantsDetailsFormDataMapper {
  const map = (formData: ParticipantsFormData) => {
    const participantsMapped = Object.entries(formData).reduce<Record<string, string>[]>((acc, [participantIndex, participantData]) => {
      const participant: Record<string, string> = {}
      Object.entries(participantData).forEach(([fieldId, value]) => {
        let mappedValue: string

        if (typeof value !== 'string' && !(value instanceof Date) && isPhoneField(fieldId as ParticipantFormFieldId)) {
          mappedValue = mapPhoneNumberToString(value)
        }
        else {
          mappedValue = value as string
        }

        if (value instanceof Date && fieldId === 'Birthdate') {
          mappedValue = value.toISOString().split('T')[0]
        }

        participant[mapFieldIdNameToApiFieldName(fieldId as ParticipantFormFieldId)] = mappedValue
      })

      return [...acc, { ...participant, id: participantIndex }]
    }, [])

    return { participants: participantsMapped }
  }

  return {
    map,
  }
}

function mapFieldIdNameToApiFieldName(fieldId: ParticipantFormFieldId) {
  return {
    Name: 'firstName',
    Surname: 'lastName',
    Email: 'email',
    Title: 'title',
    Birthdate: 'birthDate',
    StreetName: 'streetName',
    StreetNumber: 'streetNumber',
    StreetNumberAdditional: 'streetNumberAdditional',
    PostalCode: 'postalCode',
    CityName: 'cityName',
    Country: 'country',
    MobilePhoneNumber: 'mobilePhoneNumber',
    EmergencyPhoneNumber: 'emergencyPhoneNumber',
  }[fieldId]
}

function isPhoneField(fieldId: ParticipantFormFieldId) {
  return fieldId === 'MobilePhoneNumber' || fieldId === 'EmergencyPhoneNumber'
}
